import { wordService } from "../services/wordService";

export const applyReferences = () => wordService.insertLabeledSemanticBlock("references");
export const applyReference = () => wordService.applySemanticTag({ type: "reference", styleBuiltIn: "Normal" });
